import { useEffect } from 'react'

export const useCourseAfter = setDataModal => {
  useEffect(() => {
    setDataModal(null)
  }, [setDataModal])
}
